import { initI18n } from "@njbsoft/i18n";

// Detect system locale from browser
function getSystemLocale(): "en" | "es" {
  const lang = navigator.language;
  return lang.startsWith("es") ? "es" : "en";
}

// Initialize i18next for admin platform
initI18n({ lng: getSystemLocale() });
